<template>


  <div>


    <h1>HALLLOOOO </h1>

    <v-flex xs12 md6 pl-4 pa-2>
      <v-text-field
        label="REFERENCE"
        v-model="selectedItem.reference"
      ></v-text-field>
    </v-flex>


  </div>

</template>


<script>
    import {GoogleAdWords, ProductSettings, Settings} from '../../../store/namespace-helper'

    export default {
      name: 'google-ad-words',
      data () {
        return {
          existingItem: ''
        }
      },
      methods: {
        prepareGoogleAdWordSuggestions: function () {
          try {
            this.$store.dispatch(GoogleAdWords.actions.getSuggestionsForProduct, {
              item: this.existingItem
            })
          } catch (err) {
            console.error(err)
          }
        }
      },
      computed: {
        loading () {
          return this.$store.getters[Settings.getters.loading]
        },
        activeAdwordPositions () {
          return [{'test': '121213'}, {'test2': '123123123'}]
        },
        selectedItem () {
          this.existingItem = this.$store.getters[ProductSettings.getters.getSelectedProduct]
          this.prepareGoogleAdWordSuggestions()
          return this.$store.getters[ProductSettings.getters.getSelectedProduct]
        }
      }
    }
</script>



// WEBPACK FOOTER //
// src/components/ecommerce/googleAds/GoogleAdwords.vue